export default __webpack_public_path__ + "static/media/package-3.442bb5fe.svg";